<!-- loader -->
<div *ngIf="isLoading" class="loader-container">
  <mat-spinner
    diameter="20"
    style="margin-left: auto; margin-right: auto"
  ></mat-spinner>
  <p>Loading Disbursement Details...</p>
</div>
<!-- Error UI -->
<div *ngIf="hasError">
  <mat-card class="mat-elevation-z3">
    <h6 style="font-size: 15px">
      <mat-icon fontSet="material-symbols-outlined" class="err-icon"
        >error_outline</mat-icon
      >
      Unable to Load Disbursement Details
    </h6>
    <p>
      There was an error fetching the disbursement information. Please try
      again.
    </p>

    <button
      mat-raised-button
      color="primary"
      class="action-btn"
      (click)="retryFetch()"
      style="width: 10%"
    >
      <mat-icon
        fontSet="material-symbols-outlined"
        style="font-size: 17px; margin-bottom: -12px"
        >refresh</mat-icon
      >
      Retry
    </button>
  </mat-card>
</div>
<!-- Error UI -->

<!-- Actual  Disbursement Details  Ui -->
<div *ngIf="!hasError && disbursementForm" class="container theme-dark">
  <form [formGroup]="disbursementForm">
    <div style="background: var(--app-page-bg)">
      <!-- Two Cards section ui  -->
      <mat-grid-list
        cols="2"
        rowHeight="720px"
        gutterSize="20px"
        *ngIf="true"
        style="margin-bottom: 8px"
      >
        <!-- General Information Card -->
        <mat-grid-tile>
          <mat-card class="info-card2 mat-elevation-z3">
            <div class="card-header">
              <h3>General Information</h3>
              <div
                style="
                  display: flex;
                  justify-content: space-around;
                  align-content: space-around;
                "
              >
                <button
                  type="button"
                  mat-icon-button
                  class="edit-button"
                  (click)="isEditFun(1)"
                >
                  <mat-icon
                    *ngIf="isInputCard1"
                    fontSet="material-symbols-outlined"
                  >
                    edit
                  </mat-icon>

                  <mat-icon
                    *ngIf="!isInputCard1"
                    fontSet="material-symbols-outlined"
                    style="color: red"
                  >
                    close
                  </mat-icon>
                </button>
                <button
                  *ngIf="!isInputCard1"
                  mat-icon-button
                  class="save-button"
                  (click)="submitForm(1)"
                >
                  <mat-icon fontSet="material-symbols-outlined">done</mat-icon>
                </button>
              </div>
            </div>
            <mat-grid-list cols="2" rowHeight="320px">
              <mat-grid-tile>
                <div>
                  <div class="field">
                    <span>Disbursement ID</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="disbursement_id"
                    />
                  </div>
                  <div class="field">
                    <span>Port Agent</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="port_agent_name"
                    />
                  </div>
                  <div class="field">
                    <span>Client</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="client_name"
                    />
                  </div>
                  <div class="field">
                    <span>Vessel</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="vessel_name"
                    />
                  </div>
                  <div class="field">
                    <span>Country</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="country"
                    />
                  </div>
                  <div class="field">
                    <span>Port</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="port"
                    />
                  </div>
                  <div class="field">
                    <span>Purpose</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="purpose"
                    />
                  </div>
                  <div class="field">
                    <span>Cargo</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="cargo"
                    />
                  </div>
                  <div class="field">
                    <span>ETA</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      [value]="formatDate(disbursementForm.get('eta')?.value)"
                    />
                  </div>
                  <div class="field">
                    <span>ETD</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      [value]="formatDate(disbursementForm.get('etd')?.value)"
                    />
                  </div>
                  <div class="field" style="width: 100%">
                    <span style="margin-top: 15px; white-space: nowrap"
                      >PDA Remark</span
                    >
                    <textarea
                      [disabled]="isInputCard1"
                      [ngStyle]="
                        isInputCard1
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                              'text-align': 'end !important',
                            }
                          : { 'text-align': 'start !important' }
                      "
                      class="isInput"
                      formControlName="pda_remark"
                      rows="3"
                      style="width: 80%"
                      [readonly]="isInputCard1"
                    ></textarea>
                  </div>
                </div>
              </mat-grid-tile>
              <mat-grid-tile>
                <div>
                  <div class="field">
                    <span>OPS PIC</span>
                    <input
                      type="text"
                      style="width: 60%"
                      [readonly]="isInputCard1"
                      [ngStyle]="
                        isInputCard1
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="ops_pic"
                    />
                  </div>
                  <div class="field">
                    <span>Agency Nomination Date</span>
                    <mat-form-field
                      *ngIf="!isInputCard1"
                      appearance="outline"
                      class="date-picker-field"
                    >
                      <input
                        matInput
                        [matDatepicker]="agencyPicker"
                        [ngStyle]="
                          isInputCard1
                            ? {
                                'background-color':
                                  'var(--color-bg-dark-1) !important',
                                color: 'var(--color-text-light-1) !important',
                              }
                            : {}
                        "
                        formControlName="agency_nomination_date"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="agencyPicker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #agencyPicker></mat-datepicker>
                    </mat-form-field>
                    <span
                      *ngIf="isInputCard1"
                      class="isInput"
                      style="font-weight: 500; color: var(--color-white)"
                    >
                      {{
                        formatDate(
                          disbursementForm.get("agency_nomination_date")?.value
                        )
                      }}
                    </span>
                  </div>
                  <div class="field">
                    <span>PDA Received</span>
                    <mat-form-field
                      *ngIf="!isInputCard1"
                      appearance="outline"
                      class="date-picker-field"
                    >
                      <input
                        matInput
                        style="width: 60%"
                        [matDatepicker]="pdaPicker"
                        [ngStyle]="
                          isInputCard1
                            ? {
                                'background-color':
                                  'var(--color-bg-dark-1) !important',
                                color: 'var(--color-text-light-1) !important',
                              }
                            : {}
                        "
                        formControlName="pda_received_ops_agent"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="pdaPicker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #pdaPicker></mat-datepicker>
                    </mat-form-field>
                    <span
                      *ngIf="isInputCard1"
                      class="isInput"
                      style="font-weight: 500; color: var(--color-white)"
                    >
                      {{
                        formatDate(
                          disbursementForm.get("pda_received_ops_agent")?.value
                        )
                      }}
                    </span>
                  </div>
                <div class="field">
  <span>PDA Status</span>
  <input
    *ngIf="isInputCard1"
    type="text"
    readonly
    class="isInput"
    style="
      background-color: var(--color-bg-dark-1) !important;
      color: var(--color-text-light-1) !important;
    "
    formControlName="pda_status"
  />
  <select
    *ngIf="!isInputCard1"
    class="isInput status-dropdown"
    formControlName="pda_status"
    (change)="onPdaStatusChange($event)"
  >
    <option *ngFor="let status of statusOptions" [value]="status">
      {{ status }}
    </option>
  </select>
</div>
                  <div class="field">
                    <span>PDA Processing Date</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      [value]="
                        formatDate(
                          disbursementForm.get('pda_processing_date')?.value
                        )
                      "
                    />
                  </div>
                  <div class="field">
                    <span>FDA Received</span>
                    <mat-form-field
                      *ngIf="!isInputCard1"
                      appearance="outline"
                      class="date-picker-field"
                    >
                      <input
                        matInput
                        [matDatepicker]="fdaPicker"
                        [ngStyle]="
                          isInputCard1
                            ? {
                                'background-color':
                                  'var(--color-bg-dark-1) !important',
                                color: 'var(--color-text-light-1) !important',
                              }
                            : {}
                        "
                        formControlName="fda_receive_date"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="fdaPicker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #fdaPicker></mat-datepicker>
                    </mat-form-field>
                    <span
                      *ngIf="isInputCard1"
                      class="isInput"
                      style="font-weight: 500; color: var(--color-white)"
                    >
                      {{
                        formatDate(
                          disbursementForm.get("fda_receive_date")?.value
                        )
                      }}
                    </span>
                  </div>
                  <div class="field">
  <span>FDA Status</span>
  <input
    *ngIf="isInputCard1"
    type="text"
    readonly
    class="isInput"
    style="
      background-color: var(--color-bg-dark-1) !important;
      color: var(--color-text-light-1) !important;
    "
    formControlName="fda_status"
  />
  <select
    *ngIf="!isInputCard1"
    class="isInput status-dropdown"
    formControlName="fda_status"
  >
    <option *ngFor="let status of statusOptions" [value]="status">
      {{ status }}
    </option>
  </select>
</div>
                  <div class="field">
                    <span>FDA Processing Date</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      [value]="
                        formatDate(
                          disbursementForm.get('fda_processing_date')?.value
                        )
                      "
                    />
                  </div>
                  <div class="field">
                    <span>Invoice No.</span>
                    <input
                      type="text"
                      [readonly]="isInputCard1"
                      [ngStyle]="
                        isInputCard1
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="invoice_number"
                    />
                  </div>
                  <div class="field">
                    <span>Voyage</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="voyage"
                    />
                  </div>
                  <div class="field" style="width: 100%">
                    <span style="margin-top: 15px; white-space: nowrap"
                      >FDA Remark</span
                    >
                    <textarea
                      [disabled]="isInputCard1"
                      [ngStyle]="
                        isInputCard1
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="fda_remark"
                      rows="3"
                      style="width: 80%"
                      [readonly]="isInputCard1"
                    ></textarea>
                  </div>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card>
        </mat-grid-tile>

        <!-- Financial and Management Information Card -->
        <mat-grid-tile>
          <mat-card class="info-card2 mat-elevation-z3">
            <div class="card-header">
              <h3>Financial and Management Information</h3>
              <div
                style="
                  display: flex;
                  justify-content: space-around;
                  align-content: space-around;
                "
              >
                <button
                  mat-icon-button
                  class="edit-button"
                  (click)="isEditFun(2)"
                >
                  <mat-icon
                    *ngIf="isInputCard2"
                    fontSet="material-symbols-outlined"
                    >edit</mat-icon
                  >
                  <mat-icon
                    *ngIf="!isInputCard2"
                    fontSet="material-symbols-outlined"
                    style="color: red"
                    >close</mat-icon
                  >
                </button>
                <button
                  *ngIf="!isInputCard2"
                  mat-icon-button
                  class="save-button"
                  (click)="submitForm(2)"
                >
                  <mat-icon fontSet="material-symbols-outlined">done</mat-icon>
                </button>
              </div>
            </div>
            <mat-grid-list
              cols="2"
              rowHeight="260px"
              style="margin-bottom: 0; border: none"
            >
              <mat-grid-tile>
                <div style="width: 100%">
                  <div class="field">
                    <span>Estimated Amount</span>
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      class="isInput"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      formControlName="sm_estimated_amount"
                    />
                  </div>
                  <div class="field">
                    <span>PDA Amount (USD)</span>
                    <input
                      type="text"
                      [readonly]="isInputCard2"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      class="isInput"
                      formControlName="portagent_pda_amount"
                    />
                  </div>
                  <div class="field">
                    <span>FDA Amount (USD)</span>
                    <input
                      type="number"
                      readonly
                      class="isInput"
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="portagent_fda_amount"
                    />
                  </div>
                  <div class="field">
                    <span>PDA Agent Amount</span>
                    <input
                      type="text"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="manual_pda_amount"
                    />
                  </div>

                  <div class="field">
                    <span>FDA Agent Amount</span>
                    <input
                      type="text"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="manual_fda_amount"
                    />
                  </div>
                  <div class="field">
                    <span>Savings at PDA ($)</span>
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="loss_prevention_pda"
                      (input)="calculateTotalLostPrevented()"
                    />
                  </div>
                  <div class="field">
                    <span>Days Outstanding</span>
                    <input
                      type="text"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="days_outstanding"
                    />
                  </div>
                  <div class="field">
                    <span>Detailed Entry softmar(Yes/NA)</span>
                    <mat-button-toggle-group
                      *ngIf="!isInputCard2"
                      formControlName="sm_detailed_entry"
                      class="toggle-yn-group"
                    >
                      <mat-button-toggle value="Yes">Yes</mat-button-toggle>
                      <mat-button-toggle value="NA">NA</mat-button-toggle>
                    </mat-button-toggle-group>
                    <span
                      *ngIf="isInputCard2"
                      class="isInput"
                      style="font-weight: 600; color: var(--color-white)"
                      >{{
                        disbursementForm.get("sm_detailed_entry")?.value
                      }}</span
                    >
                  </div>
                  <div class="field">
                    <span>WS/Chart A/C in Softmar(Yes/NA)</span>
                    <mat-button-toggle-group
                      *ngIf="!isInputCard2"
                      formControlName="sm_ws_chart_ac"
                      class="toggle-yn-group"
                    >
                      <mat-button-toggle value="Yes">Yes</mat-button-toggle>
                      <mat-button-toggle value="NA">NA</mat-button-toggle>
                    </mat-button-toggle-group>
                    <span
                      *ngIf="isInputCard2"
                      class="isInput"
                      style="font-weight: 600; color: var(--color-white)"
                      >{{ disbursementForm.get("sm_ws_chart_ac")?.value }}</span
                    >
                  </div>
                </div>
              </mat-grid-tile>
              <mat-grid-tile>
                <div style="width: 100%">
                  <div class="field">
                    <span>Final Status</span>
                    <input
                      type="text"
                      style="width: 60%"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="final_status"
                    />
                  </div>
                  <div class="field">
                    <span
                      >PDA Remittance ({{
                        disbursementForm.get("pda_ptm_curr_to")?.value
                      }})</span
                    >
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="pda_remittance"
                    />
                  </div>
                  <div class="field">
                    <span>Agents ROE</span>
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="roe_agent"
                      (input)="calculateRoeLoss()"
                    />
                  </div>
                  <div class="field">
                    <span>Actual ROE from OANDA</span>
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="roe_actual_oanda"
                      (input)="calculateRoeLoss()"
                    />
                  </div>
                  <div class="field">
                    <span>ROE Loss USD</span>
                    <input
                      type="number"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="roe_loss"
                    />
                  </div>
                  <div class="field">
                    <span>Savings at FDA ($)</span>
                    <input
                      type="number"
                      [readonly]="isInputCard2"
                      [ngStyle]="
                        isInputCard2
                          ? {
                              'background-color':
                                'var(--color-bg-dark-1) !important',
                              color: 'var(--color-text-light-1) !important',
                            }
                          : {}
                      "
                      class="isInput"
                      formControlName="loss_prevention_fda"
                      (input)="calculateTotalLostPrevented()"
                    />
                  </div>
                  <div class="field">
                    <span>Total Savings ($)</span>
                    <input
                      type="number"
                      readonly
                      class="isInput"
                      style="
                        background-color: var(--color-bg-dark-1) !important;
                        color: var(--color-text-light-1) !important;
                      "
                      formControlName="total_loss_prevented"
                    />
                  </div>
                  <div class="field">
                    <span>Towage / Agency Agreement(Yes/NA)</span>
                    <mat-button-toggle-group
                      *ngIf="!isInputCard2"
                      formControlName="towage_agency_agrement"
                      class="toggle-yn-group"
                    >
                      <mat-button-toggle value="Yes">Yes</mat-button-toggle>
                      <mat-button-toggle value="NA">NA</mat-button-toggle>
                    </mat-button-toggle-group>
                    <span
                      *ngIf="isInputCard2"
                      class="isInput"
                      style="font-weight: 600; color: var(--color-white)"
                      >{{
                        disbursementForm.get("towage_agency_agrement")?.value
                      }}</span
                    >
                  </div>
                  <div class="field">
                    <span>Owners Items Rejected(Yes/NA)</span>
                    <mat-button-toggle-group
                      *ngIf="!isInputCard2"
                      formControlName="owners_item_rejected"
                      class="toggle-yn-group"
                    >
                      <mat-button-toggle value="Yes">Yes</mat-button-toggle>
                      <mat-button-toggle value="NA">NA</mat-button-toggle>
                    </mat-button-toggle-group>
                    <span
                      *ngIf="isInputCard2"
                      class="isInput"
                      style="font-weight: 600; color: var(--color-white)"
                      >{{
                        disbursementForm.get("owners_item_rejected")?.value
                      }}</span
                    >
                  </div>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
            <mat-grid-list cols="1" rowHeight="40px" style="margin-bottom: 0">
              <mat-grid-tile>
                <div class="field">
                  <span style="white-space: nowrap">Savings Reason</span>
                  <textarea
                    [readonly]="isInputCard2"
                    [ngStyle]="
                      isInputCard2
                        ? {
                            'background-color':
                              'var(--color-bg-dark-1) !important',
                            color: 'var(--color-text-light-1) !important',
                          }
                        : {}
                    "
                    class="isInput"
                    formControlName="loss_prevented_reason"
                    rows="3"
                    style="width: 80%"
                  ></textarea>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>

      <!-- Footer section for buttons and actions -->
      <div class="cards_footer">
        <button
          mat-raised-button
          color="primary"
          class="action-btn view-less"
          (click)="viewLessButton()"
        >
          <span>View less</span>
          <mat-icon
            fontSet="material-symbols-outlined"
            style="margin: -3px; margin-left: 2px"
          >
            expand_less</mat-icon
          >
        </button>
        <div class="dis-btn-section">
          <button
            *ngIf="
              (disbursementForm.get('fda_id')?.value &&
                disbursementForm.get('pda_id')?.value) ||
              disbursementForm.get('pda_status')?.value === 'Completed' ||
              disbursementForm.get('fda_status')?.value === 'Completed'
            "
            mat-raised-button
            class="action-btn"
            (click)="openPaymentInstructionEmailDialog()"
          >
            Payment Instruction
          </button>

          <button
            *ngIf="
              disbursementForm.get('pda_status')?.value === 'Requested' ||
              disbursementForm.get('pda_status')?.value === 'Re-Requested'
            "
            mat-raised-button
            class="nvgnt-btn"
            class="action-btn"
            (click)="resendPdaRequest()"
          >
            Resend Link
          </button>

          <button matIconButton [matMenuTriggerFor]="menu" class="action-btn">
            Download-report<mat-icon
              style="height: 15px; width: 31px; font-size: 18px"
              >download</mat-icon
            >
          </button>
          <mat-menu class="menu-report" #menu="matMenu">
            <button
              (click)="downloadReport('PDA')"
              mat-menu-item
              class="action-btn"
              [disabled]="
                disbursementForm.get('pda_status')?.value === 'Requested'
              "
            >
              <span> Download PDA Report </span>
            </button>

            <button
              (click)="downloadReport('FDA')"
              mat-menu-item
              class="action-btn"
            >
              <span> Download FDA Report </span>
            </button>
          </mat-menu>

          <button mat-raised-button (click)="upload()" class="action-btn">
            Upload
          </button>

          <button
            mat-raised-button
            class="action-btn"
            (click)="viewPDA()"
            *ngIf="disbursementForm.get('pda_id')?.value"
          >
            View PDA
          </button>

          <button
            mat-raised-button
            color="primary"
            class="action-btn"
            (click)="viewFDA()"
            *ngIf="
              disbursementForm.get('fda_id')?.value &&
              disbursementForm
                .get('fda_state')
                ?.value?.toString()
                .trim()
                .toUpperCase() !== 'D'
            "
          >
            View FDA
          </button>
          <button
            mat-raised-button
            color="primary"
            class="action-btn"
            (click)="viewTowage()"
            *ngIf="
              disbursementForm.get('pda_status')?.value === 'Completed' ||
            disbursementForm.get('fda_status')?.value === 'Completed'
            "
          >
            Add Towage
          </button>
          <button
            mat-raised-button
            color="primary"
            class="action-btn"
            (click)="addFDA()"
            *ngIf="
              disbursementForm.get('pda_status')?.value === 'Completed' &&
              (!disbursementForm.get('fda_id')?.value ||
                disbursementForm
                  .get('fda_state')
                  ?.value?.toString()
                  .trim()
                  .toUpperCase() === 'D')
            "
          >
            Add FDA
          </button>
          <button
            mat-raised-button
            class="action-btn"
            *ngIf="pdaExpenses?.length && username === 'Meraki - Operations'"
            (click)="openPdaExpenses()"
          >
         View {{expensesLabel}} Expenses
          </button>
        </div>
      </div>
      <!-- Footer section for buttons and actions -->
    </div>
  </form>
</div>
<ng-template #pdaExpensesDialog>
  <div class="dialog-header">
    <h2>Expenses Details</h2>

    <button mat-icon-button mat-dialog-close class="close-btn">
      <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="expense-content">

    <table class="expense-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Description</th>
          <th>Agent Amount $</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let expense of pdaExpenses">
          <td>{{ expense["S. No"] }}</td>
          <td>{{ expense.Description }}</td>
          <td>{{ expense["Agent Amount"] | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>

  </mat-dialog-content>
</ng-template>
